export type MenuLink = {
  label: string;
  href: string;
};

export type MenuGroup = {
  heading: string;
  links: MenuLink[];
};

export type MenuColumn = MenuGroup[];

// TODO: many of these labels don't have dedicated v2 routes yet. Items
// pointing at /v2/features or /v2/finnews are temporary fallbacks until the
// corresponding leaf pages exist.
export const menuColumns: MenuColumn[] = [
  // Column 1 — 新聞
  [
    {
      heading: "新聞",
      links: [
        { label: "要聞", href: "/finnews" },
        { label: "理財投資", href: "/wealth-management" },
        { label: "時事評論", href: "/columns/news" },
        { label: "財經新聞", href: "/finnews" },
        { label: "地產市道", href: "/property" },
        { label: "政壇脈搏", href: "/features" },
        { label: "獨眼", href: "/features" },
        { label: "兩岸消息", href: "/finnews/china" },
        { label: "EJ Global", href: "/features" },
        { label: "副刊文化", href: "/columns/culture" },
        { label: "EJ Global plus", href: "/features" },
      ],
    },
  ],
  // Column 2 — 即時 + 分析評論
  [
    {
      heading: "即時",
      links: [
        { label: "港股直擊", href: "/stock360/live" },
        { label: "香港財經", href: "/finnews/hong-kong" },
        { label: "中國財經", href: "/finnews/china" },
        { label: "國際財經", href: "/finnews" },
        { label: "地產新聞", href: "/property" },
        { label: "時事脈搏", href: "/live-news" },
      ],
    },
    {
      heading: "分析評論",
      links: [
        { label: "信報時評", href: "/columns/news" },
        { label: "地產評論", href: "/property" },
      ],
    },
  ],
  // Column 3 — 股票
  [
    {
      heading: "股票",
      links: [
        { label: "滬港通", href: "/stock360/connect" },
        { label: "即時報價", href: "/stock360/quote/0700" },
        { label: "心水組合", href: "/stock360/portfolio" },
        { label: "股票勢頭", href: "/stock360/screener" },
        { label: "今期熱炒", href: "/stock360/hot-stocks" },
        { label: "行業比拼", href: "/stock360/screener" },
        { label: "輪證", href: "/stock360/derivatives" },
        { label: "即時股評", href: "/stock360/live?category=experts" },
        { label: "IPO", href: "/stock360/ipo" },
        { label: "重要通告", href: "/stock360/live?category=notice" },
        { label: "港交所通告", href: "/stock360/live?category=notice" },
        { label: "投資頻道", href: "/stock360" },
        { label: "企業日誌", href: "/stock360/calendar" },
      ],
    },
  ],
  // Column 4 — 理財
  [
    {
      heading: "理財",
      links: [
        { label: "宏觀經濟", href: "/wealth-management/macro" },
        { label: "ETF", href: "/wealth-management/etf" },
        { label: "基金", href: "/wealth-management/funds" },
        { label: "人民幣/外匯", href: "/wealth-management/forex" },
        { label: "貴金屬", href: "/wealth-management" },
        { label: "強積金/保險", href: "/wealth-management/mpf" },
        { label: "精明移民/理財", href: "/wealth-management/investment-edu" },
      ],
    },
  ],
  // Column 5 — 生活/創科 + 地產
  [
    {
      heading: "生活/創科",
      links: [
        { label: "LJ 優雅生活", href: "/lj" },
        { label: "信健康", href: "/ej-health" },
        { label: "EJ Tech", href: "/ej-tech" },
      ],
    },
    {
      heading: "地產",
      links: [
        { label: "住宅", href: "/property" },
        { label: "工商舖", href: "/property" },
        { label: "屋苑樓價", href: "/property/estate-prices" },
        { label: "專家評論", href: "/property" },
        { label: "置業工具", href: "/property/calculator" },
      ],
    },
  ],
  // Column 6 — 專題
  [
    {
      heading: "專題",
      links: [
        { label: "美國大選 . 國際觀點", href: "/features" },
        { label: "北上熱潮", href: "/features" },
        { label: "人情味濃", href: "/features" },
        { label: "虛幣浪潮", href: "/features" },
        { label: "息賺理財通", href: "/features" },
        { label: "保險服務卓越大獎 2026", href: "/features" },
        { label: "信健康卓越大獎", href: "/features" },
        { label: "2026-27預算案：轉盈在望", href: "/features/budget-2026" },
        { label: "財經論壇2026", href: "/features" },
        { label: "AGI安聯投資新視角新機遇", href: "/features" },
      ],
    },
  ],
];

export type BrandLogo = {
  src: string;
  alt: string;
  /** Width of the mobile pill's 18px-tall logo box: 18 × the asset's aspect ratio. */
  width: number;
  href: string;
  /** include "港股360" text next to the icon per Figma */
  withText?: string;
};

// TODO: 好.賞.玩 (Happy) has no v2 route yet — points at v2 root.
//
// Seven of these marks are the advertising microsite's press-quality brand logos
// (`public/images/ratecard/*_logo.png`), trimmed of their transparent padding
// and normalised to 160px tall so every one lands at the same optical height in
// the row. 信報出版, 好.賞.玩 and ejinsight have no counterpart on that page and
// keep their original artwork and pill widths.
//
// `width` sizes the mobile pill's 18px-tall logo box. Trimming the padding
// changed the aspect ratio of every swapped mark, so each of those widths is
// re-derived as 18 × the new ratio; leaving the old value would letterbox the
// logo inside the pill's border. The desktop panel sizes its own box from the
// sidebar column and ignores this.
export const brandLogos: BrandLogo[] = [
  { src: "/images/nav-v2/brand-hkej-monthly.png", alt: "信報財經月刊", width: 93, href: "/ej-monthly" },
  { src: "/images/nav-v2/brand-ejfq.png", alt: "EJFQ", width: 33, href: "/stock360" },
  {
    src: "/images/nav-v2/brand-hkej360-icon.png",
    alt: "港股360",
    width: 18,
    withText: "港股360",
    href: "/stock360",
  },
  { src: "/images/nav-v2/brand-hkej.png", alt: "信報", width: 50, href: "/" },
  { src: "/images/nav-v2/brand-happy.png", alt: "好.賞.玩", width: 52, href: "/" },
  { src: "/images/nav-v2/brand-hkej-health.png", alt: "信健康", width: 49, href: "/ej-health" },
  { src: "/images/nav-v2/brand-lifestyle.png", alt: "LIFESTYLE Journal", width: 74, href: "/lj" },
  { src: "/images/nav-v2/brand-hkej-edu.png", alt: "信報教育", width: 56, href: "/ej-education" },
  { src: "/images/nav-v2/brand-hkej-tech.png", alt: "信報TECH", width: 43, href: "/ej-tech" },
  { src: "/images/nav-v2/brand-ejinsight.png", alt: "ejinsight", width: 53, href: "/ejinsight" },
];

export type Author = {
  name: string;
  column: string;
  avatar: string;
  href: string;
};

export const authors: Author[] = [
  { name: "高天佑", column: "新聞點評", avatar: "/images/authors/高天佑.png", href: "/columns/authors/gao-tianyou" },
  { name: "杜比", column: "投資搏擊", avatar: "/images/nav-v2/author-dubi.png", href: "/columns/authors/dubi" },
  { name: "習廣思", column: "信筆攻略", avatar: "/images/nav-v2/author-xi.png", href: "/columns/authors/xi-guangsi" },
  { name: "丁學良", column: "", avatar: "/images/authors/丁學良.png", href: "/columns/authors/ding-xueliang" },
  { name: "占飛", column: "忽然文化", avatar: "/images/nav-v2/author-zhan.png", href: "/columns/authors/zhanfei" },
  { name: "寧思雋", column: "思家投資", avatar: "/images/nav-v2/author-ning.png", href: "/columns/authors/ning-sijun" },
];
